import dynamic from 'next/dynamic';
import { LottieAnimationData } from 'libs/contentful/types';
import { DefaultAnimationSettings } from 'types/constants';
import { AnimationSettings } from 'types/sharedComponents';

interface LottieAnimationProps {
  src: LottieAnimationData | null;
  animationSettings?: AnimationSettings;
}

const Player = dynamic(() => import('@lottiefiles/react-lottie-player').then(mod => mod.Player), { ssr: false });

const LottieAnimation = ({ src, animationSettings }: LottieAnimationProps) => {
  const { autoplay, loop, controls, speed } = animationSettings || DefaultAnimationSettings;
  if (!src) {
    console.warn('LottieAnimation: No animation data or asset URL provided');
    return null;
  }

  return <Player src={src} autoplay={autoplay} loop={loop} controls={controls} speed={speed} />;
};

export default LottieAnimation;
